import React from 'react'
import cn from 'classnames'
import AspectRatioBox from '../../../components/AspectRatioBox/ApectRatioBox'
import PlayButton from './PlayButton'
import { NutritionTimes_videos_video } from '../types/NutritionTimes'

type Props = {
  video: NutritionTimes_videos_video
  selectVideo?: (video: {}) => void
  isSelected?: boolean
  name: React.ReactNode
  subheading: React.ReactNode
  placeholder?: React.ReactNode
}

const VideoThumb = ({
  video,
  selectVideo = (_video?) => {},
  isSelected,
  name,
  subheading,
  placeholder,
}: Props) => {
  if (!video.thumbnailUrl) {
    throw new Error('VideoThumb required prop missing')
  }

  return (
    <div
      className={cn(
        'group relative flex md:block',
        'px-8 py-6 md:p-8 lg:p-11',
        'rounded-8 lg:rounded-16',
        isSelected && 'bg-grey-lightest bg-opacity-40',
      )}
    >
      <div className="mt-2 w-1/3 md:mt-0 md:w-auto">
        <AspectRatioBox ratio={0.55}>
          {video && (
            <img
              src={video.thumbnailUrl}
              alt=""
              className="w-full rounded-6 object-cover lg:rounded-12"
            />
          )}
          {placeholder && (
            <div className="flex w-full items-center justify-center bg-white">
              <span className="text-20 font-demibold text-black">
                {placeholder}
              </span>
            </div>
          )}
          <div className="absolute inset-0 rounded-6 bg-black opacity-15 lg:rounded-12" />
          {video && (
            <div className="absolute inset-0 flex scale-50 transform items-center justify-center md:scale-100">
              <PlayButton />
            </div>
          )}
        </AspectRatioBox>
      </div>
      <h3 className="ml-12 w-2/3 md:ml-0 md:mt-12 md:w-auto">
        <button
          className="fill-link cursor-pointer text-left"
          onClick={() => selectVideo(video)}
        >
          <span className="mb-2 block text-green type-14-demibold-caps md:mb-4">
            {subheading}
          </span>
          <span className="sr-only">{': '}</span>
          <span
            className={cn(
              'type-default-fat mb-6 capitalize transition md:leading-body',
              'border-b-3 border-transparent group-hover:border-Brand',
            )}
          >
            {name}
          </span>
        </button>
      </h3>
    </div>
  )
}

export default VideoThumb
